import "@xterm/xterm/css/xterm.css";
import "github-markdown-css";
import "../../styles/markdown.css";
import "../../styles/overrides.css";

import { Editor } from "components/Editor/Editor";
import type { LiveSession } from "components/Editor/useEditorStore/live-session/queries";
import { EditorProvider } from "features/editor/Feature";
import type { State } from "features/editor/types";
import { NotificationsProvider } from "features/notifications/Feature";

import { SessionMatcher } from "components/SessionMatcher";
import { useEditorRouter } from "hooks/useEditorRouter";

export const EditorPageContent: React.FC<{
  liveSession?: LiveSession;
  initialState?: State;
}> = ({ liveSession, initialState }) => {
  const router = useEditorRouter();

  return (
    <SessionMatcher>
      <NotificationsProvider>
        <EditorProvider
          initialState={initialState}
          router={router}
          type={router.type === "branch" ? "branch" : "sandbox"}
        >
          <Editor liveSession={liveSession} />
        </EditorProvider>
      </NotificationsProvider>
    </SessionMatcher>
  );
};
